// extracted by mini-css-extract-plugin
export default {"colorTextLabel":"M2-z","colorTextValue":"N2-z","swatches":"O2-z","collapseLink":"P2-z","isCollapsed":"Q2-z","dropdown":"R2-z","disabled":"S2-z"};